import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import Login from "../../Authentication/Login";
import MarketingTabs from "../AllTabs/MarketingTabs";
const initialFieldValues = {
  customerId: "00000000-0000-0000-0000-000000000000",
  companyId: "00000000-0000-0000-0000-000000000000",
  customerName: "",
  phoneNumber: "",
  email: "",
};

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
const Customer = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchKeyword = useDebounce(searchKeyword, 300);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAddShow(true);
    setErrors({});
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    let resourceUrl = `${config.GETCUSTOMERBYCOMAPANYID}/${user.cid}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

    if (debouncedSearchKeyword) {
      resourceUrl += `&search=${encodeURIComponent(debouncedSearchKeyword)}`;
    }

    try {
      const res = await apiService.getAll(resourceUrl);

      if (res.data) {
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setTotalRecords(res.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLists([]);
      setTotalRecords(0);
      setTotalPages(0);
    }
  };

  useEffect(() => {
    if (user && !loading) {
      GetData();
    }
  }, [user, loading, pageNumber, debouncedSearchKeyword]);

  useEffect(() => {
    if (pageNumber !== 1) {
      setPageNumber(1);
    }
  }, [debouncedSearchKeyword]);
  // DEFINED HERE
  const handleReset = () => {
    setSearchKeyword(""); // Reset search keyword
    setPageNumber(1);
  };

  const GetPageData = (number) => {
    if (pageNumber !== number && number > 0 && number <= totalPages) {
      setPageNumber(number);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          className={`page-item ${pageNumber === i ? "active" : ""}`}
          key={i}
          onClick={() => GetPageData(i)}
        >
          <Link to="#" className="page-link">
            {i}
          </Link>
        </li>
      );
    }
    return pageNumbers;
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
    setErrors({});
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETECUSTOMER, itemToDelete);
        await GetData(pageNumber, searchTerm);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
      setPageNumber(1);
    }
  };
  const validate = () => {
    let temp = {};

    // Name validation - only letters, spaces, and certain special characters allowed
    // Prevents email addresses and phone numbers
    const namePattern = /^[a-zA-Z\s.'-]+$/;
    const emailPattern = /@/; // Check if contains @ symbol (email)
    const phonePattern = /^\d+$/; // Check if contains only digits (phone)

    temp.customerName =
      values.customerName === ""
        ? false
        : namePattern.test(values.customerName) &&
          !emailPattern.test(values.customerName) &&
          !phonePattern.test(values.customerName.replace(/\s/g, ""));

    // Phone number validation - only digits, 10-15 characters
    const phoneValidPattern = /^\d{10,15}$/;
    temp.phoneNumber =
      values.phoneNumber === ""
        ? false
        : phoneValidPattern.test(values.phoneNumber);

    // Email validation with regex pattern
    const emailValidPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    temp.email =
      values.email === "" ? false : emailValidPattern.test(values.email);

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        customerId: values.customerId,
        customerName: values.customerName,
        phoneNumber: values.phoneNumber,
        email: values.email,
        companyId: user?.cid,
      };
      try {
        const isNew =
          formData.customerId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATECUSTOMER, formData);
        } else {
          await apiService.update(config.UPDATECUSTOMER, formData);
        }
        await GetData(pageNumber, searchTerm);
        resetForm();
      } finally {
        setBtnLoading(false); // ensure loading button resets even on error
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MarketingTabs pageName="CUSTOMERS" />
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-xl-4 col-lg-6">
                      <div className="search-box">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search by Name, Email, or Phone..."
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)} // Update searchKeyword immediately
                        />
                        {/* <i className="ri-search-line search-icon"></i> */}
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-3">
                      <div className="hstack gap-2">
                        <button
                          className="btn btn-danger"
                          onClick={handleReset}
                        >
                          <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Customer
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th scope="col" style={{ width: "50px" }}>
                            S.No
                          </th>
                          <th>Customer Name</th>
                          <th>Phone Number</th>
                          <th>Email</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 ? (
                          lists.map((v, index) => (
                            <tr key={v.customerId}>
                              <td>
                                {(pageNumber - 1) * pageSize + (index + 1)}
                              </td>
                              <td>{v.customerName}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.email}</td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.customerId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center"></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={`page-item ${
                          pageNumber === 1 ? "disabled" : ""
                        }`}
                        onClick={() => GetPageData(pageNumber - 1)}
                      >
                        <Link to="#" className="page-link">
                          Previous
                        </Link>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          pageNumber === totalPages ? "disabled" : ""
                        }`}
                        onClick={() => GetPageData(pageNumber + 1)}
                      >
                        <Link to="#" className="page-link">
                          Next
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose}>
          <Modal.Header>
            <Modal.Title>
              {values.customerId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Customer
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="customerName" className="form-label">
                    Customer Name
                  </label>
                  <input
                    type="text"
                    maxLength={45}
                    value={values.customerName}
                    name="customerName"
                    onChange={handleInputChange}
                    className={
                      "form-control" + applyErrorClass("customerNumber")
                    }
                    placeholder="Please Enter Customer Name"
                  />
                  {errors.customerName === false ? (
                    <div className="validationerror">
                      {values.customerName === ""
                        ? "Please enter customer name"
                        : "Please enter a valid name "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="int"
                    value={values.phoneNumber}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("phoneNumber")}
                    placeholder="Please Enter Phone Number"
                    maxLength={15}
                  />
                  {errors.phoneNumber === false ? (
                    <div className="validationerror">
                      {values.phoneNumber === ""
                        ? "Please enter phone number"
                        : "Please enter a valid phone number"}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    maxLength={45}
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("email")}
                    placeholder="Please Enter Email"
                  />
                  {errors.email === false ? (
                    <div className="validationerror">
                      {values.email === ""
                        ? "Please enter email"
                        : "Please enter a valid email address"}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.customerId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default Customer;
